import {Component, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Apollo} from "apollo-angular";
import {MatTableDataSource} from "@angular/material/table";
import {DataFormatService} from "../../services/data-format.service";
import {FundInvestorsComponent} from "./fund-subcomponents/fund-investors/fund-investors.component";
import {DatePipe} from "@angular/common";
import {FundService, UpdateFundBudgetYearMode, UpdateFundOutletCreditMode} from "../fund-service.service";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";
import {Subscription} from "rxjs";
import {FundInformationComponent} from "./fund-subcomponents/fund-information/fund-information.component";


@Component({
    selector: 'app-fund',
    templateUrl: './fund.component.html',
    styleUrls: ['./fund.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FundComponent implements OnInit {
  public fund:any;
  @ViewChild(FundInvestorsComponent) investorsComponent: FundInvestorsComponent
  @ViewChild(FundInformationComponent) infoComponent: FundInformationComponent
  public participants:{[key:string]: any} = {
    ThirdPartyParticipants: {
      color: 'orange',
      title : 'Third Party Participants',
      dataSource: new MatTableDataSource([]),
      columns: ['role', 'participant', 'sponsor'],
      editColumns: ['role', 'participant', 'sponsor', 'actions']
    },
    CREAParticipants: {
      color: 'orange-dark',
      title: 'CREA Participants',
      dataSource: new MatTableDataSource([]),
      columns: ['role', 'participant'],
      editColumns: ['role', 'participant', 'actions']
    }
  }


  public syndicationsSequences:any = <any>[]
  private activeUsers:any[] = []
  public orgs: any[] = []
  private investorTypeId:string | null = null;
  public isCertificated:boolean = false;
  public fundProjectStates:any[] = []
  public querySubscription:Subscription;
  public specialPurposeEntityTypeId: string | null;
  public queryRef: any;
  public permissions: any;
  public dvType:string;

  public fundSubscription: Subscription;
  public specialEntitySubscription: Subscription;
  public investoryTypeSubscription: Subscription;

  constructor(private route: ActivatedRoute, private apollo: Apollo, private dataFormat: DataFormatService, public fundService: FundService, private _snackBar: MatSnackBar, private datePipe: DatePipe) {
  }

  ngOnInit() {
    this._getDetail();
    this.fundSubscription = this.fundService.fund$.subscribe((result) => {
      this.fund = result
    })
    this.specialEntitySubscription = this.fundService.specialPurposeEntityId$.subscribe((result) => this.specialPurposeEntityTypeId = result)
    this.investoryTypeSubscription = this.fundService.investorTypeIdS.subscribe((result) => this.investorTypeId = result)
  }

  _getDetail(){
    this.route.data.subscribe((dv:any) => {
      this.dvType = dv.type
      if(dv.type === 'fund'){
        this._getFundDetails();
      }
      if(dv.type === 'certificated_outlet'){
        this.isCertificated = true;
        this._getCertificatedOutletDetails()
      }
    })
  }

  _getCertificatedOutletDetails(){
    this.fundService.getCertificatedOutlets(this.route.snapshot.paramMap.get('id') ?? '')
    // this.queryRef = this.apollo.watchQuery({
    //   query: get_certificated_outlet,
    //   variables: {
    //     id: this.route.snapshot.paramMap.get('id'),
    //   },
    //   fetchPolicy: 'network-only'
    // })
    // this.querySubscription =  this.fundService.getCertificatedOutlets(this.route.snapshot.paramMap.get('id') ?? '').subscribe(({data}:any) => {
    //   this.hasLoaded = true;
    //   this.fund = data.certificatedOutlet;
    //   this.participants = this._setParticipants(data.certificatedOutlet);
    //   this.CREAParticipantRoles = data.CREARoles.roles.filter((role:any) => role.active)
    //   this.thirdParticipantRoles = data.thirdPartyRoles.roles.filter((role:any) => role.active)
    //   this.outlets = this._setCredits(data.certificatedOutlet)
    //   this.fundProjectStates = data.fund_project_states;
    //   this.permissions = data.me.fundPermissions;
    //   this.statusSequences = data.statusesBySequence
    //   this.querySubscription.unsubscribe();
    // })
  }

  _getFundDetails(){
    this.fundService.getFunds(this.route.snapshot.paramMap.get('id') ?? '')
    // this.querySubscription =  this.fundService.getFunds(this.route.snapshot.paramMap.get('id') ?? '').subscribe(({data}:any) => {
    //   this.hasLoaded = true;
    //   this.fund = data.fund;
    //   this.sequenceStatuses = data.statusesBySequence
    //   this.fundTypes = data.fundTypes;
    //   this.participants = this._setParticipants(data.fund)
    //   this.investors = this._setInvestors(data.fund)
    //   this.fundService.setInvestors(this.investors)
    //   this.outlets = this._setCredits(data.fund)
    //   this.CREAParticipantRoles = data.CREARoles.roles.filter((role:any) => role.active)
    //   this.thirdParticipantRoles = data.thirdPartyRoles.roles.filter((role:any) => role.active)
    //   this.specialPurproseEntityTypeId = data.owned_entity_type_by_name.id
    //   this.investmentClasses = data.investment_classes
    //   this.investorTypeId = data.investor_type.id
    //   this.fundProjectStates = data.fund_project_states;
    //   this.permissions = data.me.fundPermissions;
    //   this.statusSequences = data.statusesBySequence
    //   this.syndicationsSequences = data.syndicationsSequence
    //   this.investmentClasses = [...this.investmentClasses].sort((a:any, b:any) => a.name.localeCompare(b.name))
    // })
  }




  public updateFund(details: any){
    let fundId = this.fund.id
    let fundStatusId = this.fund.fundStatuses[0].id
    if(details.managing_member_id == null && details.mngMember!==null){
      this.fundService.createManagingMemberEntity(this.specialPurposeEntityTypeId, details.mngMember, fundId, (data:any) => {
        details.managing_member_id = data.owned_entity_id
        let valueData = data.createFundOwnedEntityAttribute?.ownedEntity.name
        if (this.infoComponent && this.infoComponent.infoGroup) {
          this.infoComponent.infoGroup.patchValue({
            mngMember: valueData
          });
        }
        this.refetchData(null)
      })
    } else {
      this.fundService.updateFundDetails(
        {
          ...details,
          fund_id: fundId,
          fund_status_id: fundStatusId
        },
        (response:any) => {
          if(details.managing_member_id!==null){
            details.managing_member_name = details.mngMember
            this.fundService.updateManagingMemberEntity(details, (data:any) => {})
          }
          this.fundService.updateFundInformationData(response)
          this.refetchData(null)
        });
    }
  }

  public updateParticipants(details:any){
    let saved_participants = 0
    for(let d = 0; d < details.length; d++){
      if(details[d].id){
        this.fundService.updateParticipants({
          id: details[d].id,
          person_id: details[d].keyType === 'CREAParticipants' ? details[d].participant_id : null,
          organization_id: details[d].keyType === 'ThirdPartyParticipants' ? details[d].participant_id : null,
          role_id: details[d].role_id
        }, (response:any) => {
          this.fundService.updateFundParticipantsTable(UpdateFundOutletCreditMode.UPDATE, response.data.updateFundParticipant, details[d].keyType)
          saved_participants += 1
          if(saved_participants===details.length){
            this.openSnackBar('Participants updated.', 'save-success')
          }
        })

      } else {
        this.fundService.addParticipant({
          fund_id: this.fund.id,
          person_id: details[d].keyType === 'CREAParticipants' ? details[d].participant_id : null,
          organization_id: details[d].keyType === 'ThirdPartyParticipants' ?  details[d].participant_id : null,
          role_id: details[d].role_id
        },
          this.isCertificated,
          (response:any) => {
          this.fundService.updateFundParticipantsTable(UpdateFundOutletCreditMode.ADD, response.data.addFundParticipant, details[d].keyType)
          saved_participants += 1
          if(saved_participants===details.length){
            this.openSnackBar('Participants updated.', 'save-success')
          }
        })
      }
    }

  }

  public removeParticipant(obj:any){
    this.fundService.deleteParticipant(obj.id, (response:any) => {
      this.fundService.updateFundParticipantsTable(UpdateFundOutletCreditMode.REMOVE, response, obj.key)
      this.openSnackBar('Participant removed', 'save-success')
    })
  }

  public refetchData(event:any) {
    if(this.isCertificated){
      this.fundService.getCertificatedOutlets(this.route.snapshot.paramMap.get('id') ?? '')
    } else {
      this.fundService.getFunds(this.route.snapshot.paramMap.get('id') ?? '')
    }
    this.fundService.fund$.subscribe((result) => this.fund = result)
  }

  public updateRevenueYear(details:any){
    if(details.id===null && (details.budget_amt!==null && details.syndications_budget_year!==null)){
      this.fundService.addBudgetRevenueYear(details, this.fund.id, (response:any) => {
        if(response.data){
          this.fundService.updateBudgetYearTable(UpdateFundBudgetYearMode.ADD, response.data.createSyndicationsDetail)
          this.openSnackBar("Revenue year added.", 'save-success')
        }
      })
      return;
    }
    if(details.id!==null){
      this.fundService.updateBudgetRevenueYear(details, (response:any) => {
        if(response.data){
          this.fundService.updateBudgetYearTable(UpdateFundBudgetYearMode.UPDATE, response.data.updateSyndicationsDetail)
          this.openSnackBar("Revenue year updated.", 'save-success')
        }
      })
      return;
    }
  }

  public updateInvestor(details:any){
    let savedDetail = 0;
    for(let detail of details){
        if(detail.id!==null){
          this.fundService.updateInvestor(detail, (response:any) => {
            let investor = response.data.updateFundInvestor
            let ownership_id = response.data.updateFundInvestor.ownershipInterest.id
            if(detail.investments?.length>0){
              let saved_investments = 0;
              detail.investments.forEach((investment:any) => {
                if(investment.id!==null){
                  this.fundService.updateInterestDetail(investment, (response:any) => {
                    let investmentResponse = response.data.updateOwnershipInterestDetail
                    this.fundService.updateInvestors(investor, investmentResponse, 'update')
                    saved_investments += 1
                    if(detail.investments.length === saved_investments){
                      this.openSnackBar('Investment updated', 'save-success')
                    }
                  })
                } else {
                  investment.ownership_id = ownership_id
                  this.fundService.addInterestDetail(investment, (response:any) => {
                    let investmentResponse = response.data.createFundOwnershipInterestDetail
                    investor.ownershipInterest.ownershipInterestDetail.push(investmentResponse)
                    this.fundService.updateInvestors(investor, investor.ownershipInterest.ownershipInterestDetail, 'update')
                    saved_investments += 1
                    if(detail.investments.length === saved_investments){
                      this.openSnackBar('Investment updated', 'save-success')
                    }
                  })
                }

              })
            } else {
              this.openSnackBar('Investor updated', 'save-success')
            }
          });

        } else {
          let ownedEntityObj = {
            ...detail,
            owned_entity_id: this.fund.ownedEntities[0].id,
            owner_type_id: this.investorTypeId,
            organization_id: detail.investorOrg.id
          }
          this.fundService.createFundInvestor(ownedEntityObj, (response: any) => {
            let investorResponse = response.data.createFundInvestor
            let ownership_id = response.data.createFundInvestor.ownershipInterest.id
            if (ownedEntityObj.hasOwnProperty('investments') && ownedEntityObj.investments.length > 0) {
              let saved_investments = 0;
              ownedEntityObj.investments.forEach((investment: any) => {
                investment.ownership_id = ownership_id;
                this.fundService.addInterestDetail(investment, (response:any) => {
                  let investmentResponse = response.data.createFundOwnershipInterestDetail
                  this.fundService.updateInvestors(investorResponse,investmentResponse, 'add')
                  saved_investments += 1
                  if(saved_investments==ownedEntityObj.investments.length){
                    this.openSnackBar('Investor added.', 'save-success')
                  }
                })
              })
            } else {
              this.openSnackBar("Investor added.", 'save-success')
            }
          })
        }

    }
    this.investorsComponent.toggleEdit()

  }

  public updateProjectCredit(details:any) {
    if(details!==null && details.length>0){
      let saved_outlets = 0;
      for(let i = 0; i < details.length; i++){
        if(details[i].outlet_id !== null){
          this.fundService.updateProjectCredit(details[i], (response:any) => {
            this.fundService.updateCreditsTable(UpdateFundOutletCreditMode.UPDATE, response.data.updateProjectCreditOutlet)
            saved_outlets += 1
            if(saved_outlets == details.length){
              this.openSnackBar('Credits updated.', 'save-success')
            }

          })
        } else {
          details[i].placement_status = details[i].fund_project_state_id ?? details[i].placement_status
          details[i].id = details[i].credit_id;
          this.createProjectCredit([details[i]], true, (result:any) => {
            this.fundService.updateCreditsTable(UpdateFundOutletCreditMode.ADD, result.data.createProjectCredit)
            saved_outlets += 1
            if(saved_outlets == details.length){
              this.openSnackBar('Credits updated.', 'save-success')
            }
          })
        }
      }
    }
  }

  public createProjectCredit(details:any, onCreate?:boolean, callback?: Function){
    for(let i = 0; i < details.length; i++){
      let outletVar = {
        project_credit_id: details[i].id,
        fund_id: onCreate ? details[i].fund_id : this.isCertificated ? null : this.fund.id,
        certificated_outlet_id: onCreate ? details[i].certificated_outlet_id : this.isCertificated ? this.fund.id : null,
        fund_project_state_id: details[i].placement_status,
        ownership: details[i].ownership,
        estimated_gross_equity: details[i].gross_equity,
        gross_equity: null,
        purchase_amount: null,
        admitted_date: details[i].admitted_date !== null ? this.datePipe.transform(details[i].admitted_date, 'yyyy-MM-dd') : null,
        exit_date: details[i].exit_date !== null ? this.datePipe.transform(details[i].exit_date, 'yyyy-MM-dd') : null,
        is_target: details[i].is_target ?? false,
        is_target_exit: details[i].is_target_exit ?? false,
        revenue_year: details[i].revenue_year,
        warehoused: details[i].warehoused,
        is_target_investor_approval: details[i].is_target_investor_approval,
        investor_approval_date: details[i].investor_approval_date !== null ? this.datePipe.transform(details[i].investor_approval_date, 'yyyy-MM-dd') : null,
        projected_warehouse_days: details[i].projected_warehouse_days,
        is_revenue_flagged: false,
        load_percentage: details[i].load_percentage,
        ut_irr: details[i].ut_irr
      }
      this.fundService.createProjectCreditOutlet(outletVar, (response:any) => {
        if(callback){
          callback(response)
        }
      })
    }
  }

  public removeFundCredit(event:string){
    this.fundService.deleteProjectCredit(event, (response:any) => {
      this.fundService.updateCreditsTable(UpdateFundOutletCreditMode.REMOVE, response.data.deleteProjectCreditOutlet)
      this.openSnackBar('Credit outlet removed', 'save-success')
    });
  }


  private openSnackBar(message: string, panel_class:string) {
    const config = new MatSnackBarConfig();
    config.panelClass = panel_class !== null ? [panel_class] : ['save-success'];
    config.horizontalPosition = "center";
    config.verticalPosition = "top";
    config.duration = 3000;
    this._snackBar.open(message, 'Ok', config);
  }
}
